import type { LineKind, MonthStatus } from '../../services/profit-share.service';
import { fmtMoney } from '../tracking/tracking-page.format';

/** -$50.00, not $-50.00. */
export const money = (n: number) => (n < 0 ? `-${fmtMoney(-n)}` : fmtMoney(n ?? 0));

export const signedSx = (v: number) => ({ color: v < 0 ? 'error.main' : v > 0 ? 'success.main' : 'text.secondary', fontWeight: 600 });

export const monthLabel = (m: string) =>
  new Date(`${m}-01T00:00:00Z`).toLocaleDateString('en-US', { month: 'short', year: 'numeric', timeZone: 'UTC' });

/** Months are UTC, like the statements. */
export const thisMonth = (now = new Date()) => now.toISOString().slice(0, 7);

/** Ad cost syncs late, so the server closes a month only from the 3rd of the next (UTC). */
export function closableFrom(m: string): Date {
  const d = new Date(`${shiftMonth(m, 1)}-01T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + 2);
  return d;
}

export function shiftMonth(m: string, n: number): string {
  const d = new Date(Date.UTC(Number(m.slice(0, 4)), Number(m.slice(5, 7)) - 1 + n, 1));
  return d.toISOString().slice(0, 7);
}

export const reportLink = (m: string) => {
  const last = new Date(Date.UTC(Number(m.slice(0, 4)), Number(m.slice(5, 7)), 0)).getUTCDate();
  // Conversion time, as the statements count it, whatever the viewer's report default.
  const p = new URLSearchParams({ dates: `${m}-01..${m}-${String(last).padStart(2, '0')}`, tz: '0', group: 'workspace_id', convclick: '0' });
  return `/tracking?${p.toString()}`;
};

export const KIND_LABEL: Record<LineKind, string> = {
  revenue_adjustment: 'Revenue adjustment',
  expense: 'Expense',
  waiver: 'Loss waiver',
};

export const KIND_HELP: Record<LineKind, string> = {
  revenue_adjustment: 'Changes revenue: negative when the network paid less than tracked, positive when it paid more.',
  expense: 'Something we paid on the workspace’s behalf. Reduces the month’s net.',
  waiver: 'Erases carried loss so the partner starts earning again sooner. Never becomes a payout.',
};

export const STATUS: Record<MonthStatus, { label: string; color: 'default' | 'info' | 'success' }> = {
  estimate: { label: 'Estimate', color: 'default' },
  closed: { label: 'Closed', color: 'info' },
  paid: { label: 'Paid', color: 'success' },
};
